import * as React from "react";

export function InjestForm() {
    return (
        <React.Fragment>
            <div>Injest Form Component</div>
        </React.Fragment>
    )
}